import React, {useEffect, useRef, useState} from 'react';
import {Form} from 'react-bootstrap';
import i18n from 'i18next';

export const CountryWithFlag = ({ code, name }) => {
	const [imgError, setImgError] = useState(false);

	return (
		<span className="country-with-flag d-flex align-items-center">
			{!imgError && (
				<img
					style={{ width: '24px' }}
					src={`https://flagsapi.com/${code}/shiny/24.png`}
					alt={`${name} flag`}
					onError={() => setImgError(true)}
				/>
			)}
			&nbsp;
			{name && <span className="country-name">{name}</span>}
		</span>
	);
};

export const SelectedOrganizationsList = ({selectedOrganizations}) => {
	if (!selectedOrganizations || selectedOrganizations.length === 0) {
		return null;
	}

	return (
		<div className="selected-organizations d-block w-100 mb-3">
			<div style={{fontSize: '18px', marginBottom: '3px'}}>
				{i18n.t('foedus-notified-organizations')}:
			</div>
			<div className="d-flex flex-wrap">
				{selectedOrganizations.map((so, index) => {

					return (
						<div key={so?.id || index} className="organization-item me-2">
							<CountryWithFlag code={so?.organization?.code} name={so?.nameEng || so?.name}/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export const OrganizationsList = ({organizations}) => {
	if (!organizations || organizations.length === 0) {
		return null;
	}

	return (
		<div className="selected-organizations d-block w-100 mb-3">
			<span className="d-flex flex-wrap">
				{organizations.map((org, index) => {
					return (
						<span key={org?.id || index} className="organization-item me-2">
							<CountryWithFlag code={org?.organization?.code} name={org?.nameEng || org?.name}/>
						</span>
					);
				})}
			</span>
		</div>
	);
};

export const IndeterminateCheckbox = ({ indeterminate, checked, onChange, ...props }) => {
	const ref = useRef(null);

	useEffect(() => {
		if (ref.current) {
			ref.current.indeterminate = indeterminate || false;
		}
	}, [indeterminate]);

	return (
		<Form.Check
			{...props}
			ref={ref}
			type="checkbox"
			checked={checked}
			onChange={onChange}
		/>
	);
};
